export class NewsDetailPage {
  init(): void {
    // ニュース詳細ページ
  }
}
